import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateCompanyDto = ClientInferRequest<typeof contract.company.update>["body"];

type UpdateResponseCompanyDto = ClientInferResponseBody<typeof contract.company.update>;

export const updateCompany = async (
  payload: UpdateCompanyDto,
): Promise<UpdateResponseCompanyDto | null> => {
  const response = await api.company.update.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update Company", response.status, response.body);
};
